<template>
    <div class="link-notice-container" :style="containerStyles">
        <div class="link-notice-wrapper" :style="contentStyles">
            <link-move-container>
                <link-move-item v-for="(option) in noticeOptions" :key="option.id">
                    <link-notice
                        :message="option.message"
                        :title="option.title"
                        :type="option.type"
                        :auto-close="option.autoClose"
                        :duration="option.duration"
                        :render-func="option.renderFunc"
                        :shape="option.shape"
                        :closable="option.closable"
                        @close="_handleClose(option)"/>
                </link-move-item>
            </link-move-container>
        </div>
    </div>
</template>

<script>

    import LinkNotice from './link-notice';
    import LinkMoveContainer from '../move/link-move-container';
    import LinkMoveItem from '../move/link-move-item';

    const LinkNoticeContainer = {
        name: 'link-notice-container',
        components: {
            LinkNotice,
            LinkMoveContainer,
            LinkMoveItem,
        },
        props: {
            horizontal: {
                type: String,
                default: 'end',
                validator(val) {
                    return LinkUtils.oneOf(val, ['start', 'center', 'end']);
                },
            },
            vertical: {
                type: String,
                default: 'start',
                validator(val) {
                    return LinkUtils.oneOf(val, ['start', 'center', 'end']);
                },
            },
        },
        data() {
            return {
                noticeOptions: []
            };
        },
        methods: {
            addNotice(options) {
                options.id = LinkUtils.uuid();
                options.close = () => this._handleClose(options);
                this.noticeOptions.push(options);
                return options;
            },
            _getContainerStylesData() {
                return {
                    [this.horizontal === 'end' ? 'right' : 'left']: this.horizontal === 'center' ? 50 : 0,
                    [this.vertical === 'end' ? 'bottom' : 'top']: this.vertical === 'center' ? 50 : 0,
                };
            },
            _handleClose(option) {
                this.noticeOptions.splice(this.noticeOptions.indexOf(option), 1);
            },
        },
        computed: {
            containerStyles() {
                let containerStyles = this._getContainerStylesData();
                Object.keys(containerStyles).forEach(key => containerStyles[key] = `${containerStyles[key]}%`);
                return containerStyles;
            },
            contentStyles() {
                let contentStyles = this._getContainerStylesData();
                Object.keys(contentStyles).forEach(key => contentStyles[key] = `${-contentStyles[key]}%`);
                return contentStyles;
            },
        },
        newInstance(props) {
            const component = new Vue({
                render(h) {
                    return h(LinkNoticeContainer, {props});
                },
            });
            const instance = component.$mount();
            document.body.appendChild(instance.$el);
            return instance.$children[0];
        }
    };

    export default LinkNoticeContainer;
</script>
<style lang="scss">
    @include themeify{
        .link-notice-container {
            position: absolute;
            z-index: 1;
            .link-notice-wrapper {
                position: relative;
                overflow: hidden;
            }

            .link-notice {
                background-color: $color-normal-background;
                min-width: 256px;
                min-height: 100px;
                margin-bottom: 0.5em;
                margin-right: 0.5em;
                /*shape*/
                @each $key, $value in $list-shape {
                    &.am-notice-shape-#{$key} {
                        border-radius: $value;
                        overflow: hidden;
                    }
                }
                .link-notice-default {
                    box-sizing: border-box;
                    .link-notice-default-content-title {
                        padding: 0.5em;
                        display: flex;
                        align-items: center;
                        justify-content: space-between;
                        .link-notice-default-content-close-icon {
                            @include transition-all;
                            &:hover {
                                transform: rotate(180deg);
                            }
                        }
                    }
                    .link-notice-default-content-message {
                        padding: 0.5em;
                    }
                }
            }

        }

    }
</style>
